import { f as a } from "./fails.js";
import { w as t } from "./well-known-symbol.js";
import { d as e } from "./descriptors.js";
import { i as r } from "./is-pure.js";
var s = t("iterator"),
  o = !a(function () {
    var a = new URL("b?a=1&b=2&c=3", "http://a"),
      t = a.searchParams,
      o = new URLSearchParams("a=1&a=2"),
      n = "";
    return a.pathname = "c%20d", t.forEach(function (a, e) {
      t.delete("b"), n += e + a;
    }), o.delete("a", 2), r && (!a.toJSON || !o.has("a", 1) || o.has("a", 2)) || !t.size && (r || !e) || !t.sort || "http://a/c%20d?a=1&c=3" !== a.href || "3" !== t.get("c") || "a=1" !== String(new URLSearchParams("?a=1")) || !t[s] || "a" !== new URL("https://a@b").username || "b" !== new URLSearchParams(new URLSearchParams("a=b")).get("a") || "xn--e1aybc" !== new URL("http://тест").host || "#%D0%B1" !== new URL("http://a#б").hash || "a1c3" !== n || "x" !== new URL("http://x", void 0).host;
  });
export { o as u };